import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Navbar, NavbarBrand, Nav, NavItem, Image  } from 'components/qstrap'
import Footer from 'components/organisms/Footer'
import Breadcrumb from 'components/molecules/Breadcrumb'

const ScholarshipTemplate = ({ children, path }) => {
  const breadcrumbPaths = [
    { name: 'Quipper Scholarship Challenge', url: '#' },
    { name: 'Pengumuman', url: '/scholarship' },
  ]

  return (
    <div id="ScholarshipTemplate">
      <Navbar light full fixed="top" className="navbar-shadow">
        <div className="nav-inner-container">
          <NavbarBrand className="sm-up-m-r-lg" href="/">
            <Image src="/assets/img/logo/qc_logo_c.svg" className="campus-logo hidden-sm-down" />
            <Image src="/assets/img/logo/qc_small_logo.png" className="hidden-md-up mobile-nav-logo" />
          </NavbarBrand>

          <Nav navbar right>
            <NavItem className={path === '/scholarship' ? 'active' : ''}>
              <Link className="nav-link" to="/scholarship">Pengumuman</Link>
            </NavItem>
            <NavItem className={path === '/scholarship/about' ? 'active' : ''}>
              <Link className="nav-link" to="/scholarship/about">Tentang</Link>
            </NavItem>
          </Nav>
        </div>
      </Navbar>

      <Breadcrumb paths={breadcrumbPaths} />

      { children }

      <Footer />
    </div>
  )
}

ScholarshipTemplate.propTypes = {
  path: PropTypes.string,
}

export default ScholarshipTemplate
